<template>
    <div class="page">
        <Section>
            <h1 class="text-h3 font-weight-bold mb-2">{{ t('services.title') }}</h1>
            <p class="text-medium-emphasis mb-8">{{ t('services.subtitle') }}</p>
            <v-row>
                <v-col
                    v-for="item in items"
                    :key="item.title"
                    cols="12"
                    md="6"
                >
                    <FeatureCard
                        :icon="item.icon"
                        :title="item.title"
                        :description="item.desc"
                    />
                </v-col>
            </v-row>
        </Section>
        <Section>
            <v-card class="pa-6">
                <h2 class="text-h5 font-weight-bold mb-2">{{ t('services.setup.title') }}</h2>
                <p class="text-medium-emphasis">{{ t('services.setup.desc') }}</p>
            </v-card>
        </Section>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import Section from '@/components/Section.vue'
    import FeatureCard from '@/components/FeatureCard.vue'
    import { useTranslations } from '@/composables/useTranslations'
    import { useSEO } from '@/composables/useSEO'

    const { t, get } = useTranslations()
    useSEO({
        title: () => t('seo.services.title'),
        description: () => t('seo.services.description'),
    })

    interface ServiceItem {
        icon: string
        title: string
        desc: string
    }
    const items = computed<ServiceItem[]>(() => get<ServiceItem[]>('services.items') ?? [])
</script>
